"use strict";

exports.__esModule = true;
exports["default"] = createNamedRoutesMiddleware;

var _Matcher = _interopRequireDefault(require("found/lib/Matcher"));

var _createMatcherNamedRoutesMiddleware = _interopRequireDefault(require("./createMatcherNamedRoutesMiddleware"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function createNamedRoutesMiddleware(routeConfig) {
  return (0, _createMatcherNamedRoutesMiddleware["default"])(new _Matcher["default"](routeConfig));
}

module.exports = exports.default;